import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr'
import Axios from 'axios';
import { i18n } from '../../translate/i18n';
import { IDataExport } from '../reducers/dataExports';
let CancelToken = Axios.CancelToken;
let fetchDataExports_cancel;

export const requestDataExportsStart = (isPooling: boolean) => {
  return {
    type: actionTypes.REQUEST_DATA_EXPORTS_START,
    isPooling,
  };
};

export const fetchDataExportsSuccess = (response: { count: number, rows: IDataExport[]}) => {
  return {
    type: actionTypes.FETCH_DATA_EXPORTS_SUCCESS,
    payload: response
  };
};

export const requestDataExportsFail = (error: any) => {
  return {
    type: actionTypes.REQUEST_DATA_EXPORTS_FAIL,
    error: error
  };
};

export const requestSignDataExportStart = (dataExportId: string) => {
  return {
    type: actionTypes.REQUEST_SIGN_DATA_EXPORT_START,
    payload: dataExportId,
  };
};

export const fetchSignDataExportSuccess = (response: IDataExport) => {
  return {
    type: actionTypes.FETCH_SIGN_DATA_EXPORT_SUCCESS,
    payload: response
  };
};

export const requestSignDataExportFail = (error: any) => {
  return {
    type: actionTypes.REQUEST_SIGN_DATA_EXPORT_FAIL,
    error: error
  };
};

export const fetchDataExports = (
  page: number,
  limit: number,
  orderBy: string,
  order: string,
  isPooling: boolean = false,
) => {
  return (dispatch: any) => {
    dispatch(requestDataExportsStart(isPooling));
    
    const  queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
  
    API.get('/dataexports' + queryParams, {
      cancelToken: new CancelToken(function executor(c) {
        fetchDataExports_cancel = c;
      })
    }).then(res => {
      dispatch(fetchDataExportsSuccess(res.data));
    })
    .catch(err => {
      dispatch(requestDataExportsFail(err));
    });
  };
};

export const signDataExport = ( dataExportId: string ) => {
  return (dispatch: any) => {
    dispatch(requestSignDataExportStart(dataExportId));
      
    API.get('/dataexports/signDataExport/' + dataExportId, {
      cancelToken: new CancelToken(function executor(c) {
        fetchDataExports_cancel = c;
      })
    }).then(res => {
      window.open(res.data.file.url);
      dispatch(fetchSignDataExportSuccess(res.data));
    })
    .catch(err => {
      dispatch(requestSignDataExportFail(err));
    });
  };
};
